<template>
  <div :class="componentClassName">
    <a-avatar class="a-calling-customer-info__avatar" />
    <div v-if="!outbound" class="a-calling-customer-info__title">
      <span>{{ displayTitle }}</span>
    </div>
    <div
      v-if="outbound"
      :title="fulltitle"
      class="a-calling-customer-info__title a-calling-customer-info__outbound-title"
    >
      <span v-text="displayTitle" />
    </div>
    <div v-if="displaySubtitleArea()" class="a-calling-customer-info__subtitle">
      <span class="a-calling-customer-info__subtitle-number">{{ phoneNumber }}</span>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AAvatar from '@/components/atoms/avatar';
import { utils } from '@/common/utils.js';

export default {
  name: 'a-calling-customer-info',
  components: {
    AAvatar,
  },
  mixins: [utils],
  props: {
    class: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    displayName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    minimized: {
      type: Boolean,
      default: false,
    },
    pbSettingName: {
      type: String,
      default: '',
    },
    callIsIncomming: {
      type: Boolean,
      default: false,
    },
    outbound: {
      type: Boolean,
      default: false,
    },
    fulltitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-calling-customer-info', this.minimized ? 'minimized' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
    pushNumberSettingName() {
      return this.collapseText(this.pbSettingName, 10);
    },
    displayTitle() {
      const titleString = this.title ? this.title : this.displayName;
      if (this.isPhoneNumber(titleString)) return titleString;
      return this.callIsIncomming || this.minimized ? this.collapseText(titleString, 10) : titleString;
    },
    displaySubtitle() {
      return this.callIsIncomming || this.minimized ? this.collapseText(this.subtitle, 10) : this.subtitle;
    },
    subtitleCollapsed() {
      return this.collapseText(this.subtitle, 10);
    },
  },
  methods: {
    displaySubtitleArea() {
      return (
        !this.minimized &&
        ((this.title && !this.isPhoneNumber(this.title)) || (this.displayName && !this.isPhoneNumber(this.displayName)))
      );
    },
  },
};
</script>
